<div class="card-title">
  @if (cardTitle()) {
    <p class="small bold">{{ cardTitle() }}</p>
  }
  <ng-content select="[cardTitle]"></ng-content>
</div>
<ng-content></ng-content>
